import { SystemField } from "./system-field";

export class ProductTranslationHistory extends SystemField{
     
     branch_id?:string;
     warehouse_id?:string;
     location_id?:string;
     product_id?:string;
     transaction_date?:string;
     lot_serial_num?:string;
     expired_date?:string;
     qty?:number;
     fin_period?:string;
     unitprice?:number;
     trans_amt?:number;
}